import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 20,
  medium: 13,
  small: 10,
  xSmall: 8
};
const DropdownIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.1814 11L21 11.6448L14.5 18.8179L8 11.6448L8.78228 11L14.5 17.2061L20.1814 11Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.1814 11L21 11.6448L14.5 18.8179L8 11.6448L8.78228 11L14.5 17.2061L20.1814 11Z",
        fill: "currentColor"
      }
    )
  );
};
DropdownIcon.iconName = "DropdownIcon";

export { DropdownIcon };
